/* eslint-disable react-hooks/rules-of-hooks */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useTranslate from '~hooks/useTranslate/useTranslate';
import AdminButton from '~atoms/admin/translate'; 
import { Context } from '~context/MainProvider.js';
import keygen from '~helpers/keygen';
import styles from './selling-points.module.scss';

const SellingPoints = ({ sellingPoints, icon, limit = 3, customClass }) => {
  const { admin, showTranslationKeys, language } = useContext(Context) || {};
  if (!sellingPoints || sellingPoints.length === 0) {
    return <></>;
  }
  
  return (
    <ul className={`${styles.sellingPoint || ''} ${customClass ? customClass || '' : ''}`}>
      {sellingPoints.slice(0, limit).map((item) => (
        <li className={`${!icon && (styles.tick || '')}`} key={keygen()}>
          {icon !== null && icon}
          {useTranslate(item, item)}
          {admin && showTranslationKeys && <AdminButton translationKey={item} language={language} />}
        </li>
      ))}
    </ul>
  );
};

SellingPoints.propTypes = {
  sellingPoints: PropTypes.arrayOf(PropTypes.string),
  icon: PropTypes.element,
  limit: PropTypes.number,
  customClass: PropTypes.string,
};

export default SellingPoints;
